import { useState, useEffect } from "react";


import './calendar.css';


function Calendar(props)
{
    var dt = new Date();
    var dtFirst = new Date(dt.getFullYear(), dt.getMonth(), 1);


    //const [tab, setTab] = useState(null);
    /**
     * props.tab = [{
     *      date: 2024-02-12
     *      title: "cos tam",
     *      className: "hide.."
     * }]
     */

 
   
    const [dayWeek, setDayWeek] = useState( dtFirst.getDay() ); // returns a number representing the day of the week, starting with 0 for Sunday 
    const [day, setDay]         = useState( dt.getDate() );
    const [month, setMonth]     = useState( dt.getMonth()+1 );
    const [year, setYear]       = useState( dt.getFullYear() );    



    const goBack = () => {

        var y = year;
        var m = month;

        if(month > 1)
        {
            m--;
        }else
        {
            m = 12;
            y--;
        }

        var dtx = new Date(y, m-1, day);
        console.log("goBack: " +  dtx );

        var dtFirst = new Date(dtx.getFullYear(), dtx.getMonth(), 1);

        setDayWeek(dtFirst.getDay() );
        setDay(dtx.getDate());
        setMonth(dtx.getMonth()+1);
        setYear(dtx.getFullYear());

        if(props.onMonthChange != undefined)
            {
                    props.onMonthChange( dtx.getFullYear(),  dtx.getMonth()+1  );
            }
    }


    const goNext = () => {
        var y = year;
        var m = month;

        if(month < 12)
        {
            m++;
        }else
        {
            m = 1;
            y++;
        }

        var dtx = new Date(y, m-1, day);
        console.log("goNext: " +  dtx );

        var dtFirst = new Date(dtx.getFullYear(), dtx.getMonth(), 1);

        setDayWeek(dtFirst.getDay() );
        setDay(dtx.getDate());
        setMonth(dtx.getMonth()+1);
        setYear(dtx.getFullYear());

        if(props.onMonthChange != undefined)
        {
            props.onMonthChange( dtx.getFullYear(),  dtx.getMonth()+1  );
        }

    }


    const goBackYear = () => {

        var y = year;
        var m = month;
 
        y--;

        var dtx = new Date(y, m-1, day);
        console.log("goBack: " +  dtx );

        var dtFirst = new Date(dtx.getFullYear(), dtx.getMonth(), 1);

        setDayWeek(dtFirst.getDay() );
        setDay(dtx.getDate());
        setMonth(dtx.getMonth()+1);
        setYear(dtx.getFullYear());

        if(props.onMonthChange != undefined)
        {
                props.onMonthChange( dtx.getFullYear(),  dtx.getMonth()+1  );
        }
    }


    const goNextYear = () => {
        var y = year;
        var m = month;

        y++;

        var dtx = new Date(y, m-1, day);
        console.log("goNext: " +  dtx );

        var dtFirst = new Date(dtx.getFullYear(), dtx.getMonth(), 1);

        setDayWeek(dtFirst.getDay() );
        setDay(dtx.getDate());
        setMonth(dtx.getMonth()+1);
        setYear(dtx.getFullYear());

        if(props.onMonthChange != undefined)
            {
                    props.onMonthChange( dtx.getFullYear(),  dtx.getMonth()+1  );
            }

    }


    const clickOnDay = (e) => {

        var date = e.target.getAttribute('date');
        var title = e.target.getAttribute('title');

        console.log("Calendar " + date + " " + title);

        if(props.clickOnDay != null && props.clickOnDay != undefined)
        {
            props.clickOnDay(date, title);
        }
    }


    var dzien = "Calendar: " + year + "-" + month + "-" + day + " ofWkk " + dayWeek;    

    var d = new Date(year, month, 0);
    var lastDay = d.getDate();

    const countWeek = () => {
    
        const firstDayMonth = new Date(year, month - 1, 1); 
        const lastDayMonth = new Date(year, month, 0); 
      
        const dayCount = lastDayMonth.getDate();
        const firstDayOfWeek = firstDayMonth.getDay(); 
        
        const firstDayOfWeekMon = (firstDayOfWeek + 6) % 7;
      
        const rowCount = Math.ceil((dayCount + firstDayOfWeekMon) / 7);
      
        return rowCount;

    };

    var week_count = countWeek();

    var calD = [];

    for(var i=0; i<week_count; i++)
    {
        calD.push([' ',' ',' ',' ',' ',' ',' ']);
    }

    var dayX = 0;

    for(var row=0; row<calD.length; row++)
    {
        for(var dd=0; dd<7; dd++)
        {
            if(dayX > lastDay) break;
            if(dd == 0 && dayWeek ==1 && dayX==0 ) {dayX = 1;}else
            if(dd == 1 && dayWeek ==2 && dayX==0 ) {dayX = 1;}else
            if(dd == 2 && dayWeek ==3 && dayX==0 ) {dayX = 1;}else
            if(dd == 3 && dayWeek ==4 && dayX==0 ) {dayX = 1;}else
            if(dd == 4 && dayWeek ==5 && dayX==0 ) {dayX = 1;}else
            if(dd == 5 && dayWeek ==6 && dayX==0 ) {dayX = 1;}else 
            if(dd == 6 && dayWeek ==0 && dayX==0 ) {dayX = 1;}else {}

            
            
            if(dayX == 0)
            {
                calD[row][dd] = {
                    date: '',
                    day: '',
                    title: '',
                    dw: '',
                    rows: []
                }; 
            }else
            {

                var strM = month+"";
                if(strM.length == 1) strM = "0" + strM;

                var strD = dayX+"";
                if(strD.length == 1) strD = "0" + strD;

                var dateX  = year+"-"+strM+"-"+strD;
                var titleX = "...";
                var classNameX = " ";

                for(var p=0; p<props.tab.length;p++)
                {
                    if(props.tab[p].date == dateX)
                    {
                        titleX = props.tab[p].title;
                        classNameX = props.tab[p].className;                    
                    }           
                }

                calD[row][dd] = {
                    date: dateX,
                    day: dayX,
                    title: titleX,
                    dw: dd,
                    className: classNameX,
                    rows: []
                }; 
            }

            if(dayX>0)
            dayX++;
        }
    }


    var monthName = "";
    if(month == 1) monthName = "Styczeń";
    if(month == 2) monthName = "Luty";
    if(month == 3) monthName = "Marzec";
    if(month == 4) monthName = "Kwiecień";
    if(month == 5) monthName = "Maj";
    if(month == 6) monthName = "Czerwiec";
    if(month == 7) monthName = "Lipiec";
    if(month == 8) monthName = "Sierpień";
    if(month == 9) monthName = "Wrzesień";
    if(month == 10) monthName = "Październik";
    if(month == 11) monthName = "Listopad";
    if(month == 12) monthName = "Grudzień";



    return (
        <div>
          
            <div className="calView1 ">
                <table className="callTab">
                    <tr>
                        <td onClick={goBackYear} className="clink fbold calColor">«</td>
                        <td onClick={goBack} className="clink fbold calColor"> &#8592; </td>                       
                        <td colSpan={3} className="calTitle calColor">{monthName} {year}</td>                    
                        <td onClick={goNext} className="clink fbold calColor">&#8594;</td>
                        <td onClick={goNextYear} className="clink fbold calColor">»</td>
                    </tr>
                    <tr className="days">
                        <td>PN</td>
                        <td>WT</td>
                        <td>ŚR</td>
                        <td>CZ</td>
                        <td>PT</td>
                        <td>SB</td>
                        <td>ND</td>
                    </tr>

                    {
                        calD.map( (week, ixWeek) => {
                              return (
                                    <tr className="dinside">
                                            {
                                                week.map( (px, inxDay) => {


                                                    var classTD = "";

                                                    if(px.dw == 5 || px.dw== 6) classTD = " cweek "

                                                    classTD = classTD + " " + px.className;

                                                    return (
                                                        <td className={"clink " + classTD}  >
                                                           <div className="tdr" title={px.title} date={px.date} onClick={clickOnDay}>{px.day}</div>
                                                        </td>
                                                    )
                                                } )
                                            }
                                    </tr>
                              )
                        } )
                    }

                </table>
            </div>
        </div>
    )
}




export default Calendar;